var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UnifiedBar',{attrs:{"show-nav-toggle":_vm.showNavToggle},on:{"toggle-drawer":function($event){return _vm.$emit('toggle-drawer')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }